import { Fragment } from "react"
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import FormInput from "../Common/FormInputs/MuiTextField";
import AppCheckbox from "../Common/FormInputs/AppCheckbox";

const additionalInfoFieldRowSx = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", md: "200px minmax(0, 280px)" },
  alignItems: "center",
  gap: 1.5,
  marginBottom: 2,
  "&:last-of-type": { marginBottom: 0 },
};
const formControlSx = (theme) => ({
  width: "100%",
  minWidth: 0,
  boxSizing: "border-box",
  [theme.breakpoints.up('md')]: { maxWidth: 280 },
});
const sectionCardSx = {
  p: 2,
  mt: 1.5,
  boxShadow: 2,
  borderRadius: 1,
};

const AdditionalInformation = ({
  feedbackRequired,
  handleFeedbackRequired,
  notificationTag,
  handleNotificationTag
}) => {
  const theme = useTheme();
  return (
    <Fragment>
      <Typography variant="subtitle1" fontWeight={600} sx={{ mt: 2 }}>
        Additional Information
      </Typography>
      <Paper sx={sectionCardSx}>
        <Box sx={additionalInfoFieldRowSx}>
          <Typography variant="body2" fontWeight={600}>Feedback Required</Typography>
          <Box>
            <AppCheckbox
              checked={feedbackRequired}
              onChange={(e) => {
                handleFeedbackRequired(e.target.checked)
              }}
              color="default"
              label="Feedback Required"
              sx={{ ml: "-11px" }}
            />
          </Box>
        </Box>
        <Box sx={additionalInfoFieldRowSx}>
          <Typography variant="body2" fontWeight={600}>Notification Tag</Typography>
          <Box sx={formControlSx(theme)}>
            <FormInput
              placeholder="Enter Notification Tag"
              value={notificationTag}
              onChange={(e) => handleNotificationTag(e.target.value)}
            />
          </Box>
        </Box>
      </Paper>
    </Fragment>
  )
}

export default AdditionalInformation